// favorite (add, remove)
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import utils from './utils'
import { getRefreshedToken } from './auth'

const initStatus = utils.initStatus(['getCharities', 'getCharityChoice', 'setCharityChoice'])
const initialState = {
	charities: [],
	choice: '',
	status: initStatus,
}
export const getCharities = createAsyncThunk('charity/getCharities', async (data, thunkAPI) => {
	try {
		const { token } = utils.getAuth(thunkAPI.getState())
		if (!token) {
			return thunkAPI.rejectWithValue({ data: { message: 'Null token' } })
		}

		const res = await axios.get(`/app/charities`, {
			headers: { Authorization: `Bearer ${token}` },
		})

		if (res.status == 200) {
			return res.data
		}
		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})
export const getCharityChoice = createAsyncThunk(
	'charity/getCharityChoice',
	async (data, thunkAPI) => {
		try {
			const { currBranch, token } = utils.getAuth(thunkAPI.getState())
			if (!token) {
				return thunkAPI.rejectWithValue({ data: { message: 'Null token' } })
			}

			const res = await axios.get(`/merchant/get/charity/${currBranch}`, {
				headers: { Authorization: `Bearer ${token}` },
			})

			if (res.status == 200) {
				return res.data
			}
			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err)
		}
	}
)

export const setCharityChoice = createAsyncThunk(
	'charity/setCharityChoice',
	async (choice, thunkAPI) => {
		try {
			const { user, currBranch, token } = utils.getAuth(thunkAPI.getState())
			if (!token) {
				return thunkAPI.rejectWithValue({ data: { message: 'Null token' } })
			}

			const res = await axios.put(
				`/merchant/edit/charity/${currBranch}`,
				{ choice, id: user.id },
				{ headers: { Authorization: `Bearer ${token}` } }
			)

			if (res.status == 200) {
				thunkAPI.dispatch(getCharityChoice())
				return res.data
			}
			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err)
		}
	}
)

export const slice = createSlice({
	name: 'charity',
	initialState,
	reducers: {
		clearState: (state, { payload }) => {
			utils.clearStatus(state, initStatus, payload)
		},
	},
	extraReducers: {
		/*
    Get Charities
    */
		[getCharities.fulfilled]: (state, { payload }) => {
			const { data, message } = payload

			state.charities = data

			utils.handleSuccess(state.status.getCharities, { message, status: 200 })

			return state
		},
		[getCharities.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getCharities, payload?.data),
		[getCharities.pending]: state => utils.handleLoading(state.status.getCharities),

		/*
    Get Charity Choice
    */
		[getCharityChoice.fulfilled]: (state, { payload }) => {
			const { data, message } = payload
			state.choice = data

			utils.handleSuccess(state.status.getCharityChoice, { message, status: 200 })

			return state
		},
		[getCharityChoice.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getCharityChoice, payload?.data),
		[getCharityChoice.pending]: state => utils.handleLoading(state.status.getCharityChoice),

		/*
    Set Charity Choice
    */
		[setCharityChoice.fulfilled]: (state, { payload }) => {
			const { data, message } = payload
			state.choice = data

			utils.handleSuccess(state.status.setCharityChoice, { message, status: 200 })

			return state
		},
		[setCharityChoice.rejected]: (state, { payload }) =>
			utils.handleError(state.status.setCharityChoice, payload?.data),
		[setCharityChoice.pending]: state => utils.handleLoading(state.status.setCharityChoice),
	},
})

// export const {clearState} = slice.actions
// module.exports.clearStateFavorite =  slice.actions.clearState
export default slice.reducer
